import { useState } from "react";
import toast from "react-hot-toast";

const InviteFreelancer = ({ onClose, handleInvite, projectList }) => {
  const [projectId, setProjectId] = useState();
  const handleSubmit = (data) => {
    handleInvite(data);
  };

  return (
    <div
      className="modal d-block ct_congratulation_modal_fade ct_reactivate_account"
      tabIndex="-1"
    >
      <div
        className="modal-dialog modal-dialog-centered ct_modal-dialog"
        style={{ maxWidth: "600px" }}
      >
        <div className="modal-content ct_p_30 ct_border_radius_20">
          <div className="modal-header border-0 p-0 ct_mb_30">
            <div>
              <h4 className="mb-1 ct_fs_20">Invite Freelancer</h4>
            </div>
            <button
              type="button"
              className="btn-close ct_circle_close"
              aria-label="Close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body p-0">
            <form className="ct_modal_scroll ct_custom_scroll px-4 pb-3 ">
              <div className="row">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group ct_mb_20">
                      <label className="ct_fs_14 ct_darkblue_text mb-2">
                        Projects
                      </label>
                      <select
                        value={projectId}
                        onChange={(e) => setProjectId(e.target.value)}
                        className="form-control ct_input ct_fs_12"
                      >
                        <option value={""}>Select project</option>
                        {projectList?.map((item, index) => (
                          <option value={item?.id}>
                            {item?.project_title || "#N/A"}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center gap-3 justify-content-end ">
                <button
                  className="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 ct_h_44"
                  type="button"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button
                  className="ct_yellow_btn px-5 ct_h_44"
                  type="button"
                  onClick={() => {
                    if (!projectId) {
                      return toast.error("Please select a project");
                    }
                    handleSubmit(projectId);
                  }}
                >
                  Continue
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InviteFreelancer;
